export const Line = ({ isDesktop }: { isDesktop?: boolean }) => {
  return (
    <div
      className={`bg-[#F8F9FA] h-2 -mx-4 ${isDesktop ? 'hidden lg:block' : ''}`}
    />
  );
};
